<script lang="ts">
    import AttributesPage from '@Alternatives/Attributes/Pages/AttributesPage'
    export default AttributesPage
</script>

<template>
    <div>
        <AttributeEditorDialog :viewModel="attributeEditorDialog"
                               @attribute-created="attributeCreated"
                               @attribute-updated="attributeUpdated" />


        <AttributeDeleterDialog :viewModel="attrDeleterDialog"
                                @delete-attribute="handleDeleteAttributeCommand"
                                @show-dependencies="showAttributeDependenciesViewer" />

        <AttributeDependenciesDialog :viewModel="attrDependenciesDialog" />


        <AttributesSectionEditor :viewModel="attributesSectionEditor"
                                 @update-section-name="handleRenameAttributesSectionCommand" />

        <PortfolioOrDecisionNavigation :workspaceId="workspaceId" :projectId="projectId" />

        <div v-if="rm" class="container" style="margin-top: 80px; padding-top: 40px;">
            <div class="row">
                <div class="col-lg-6 d-flex align-items-center">
                    <h1 style="font-size: 2em; font-weight: 300; color: #33475b; margin: 0;">Attributes</h1>
                </div>
                <div class="col-lg-6 text-right align-self-end">
                    <button role="button" class="btn btn-outline-secondary" style="padding: 0.7em 2em;" @click="toggleExpandAll">Collapse / Expand all</button>

                    <button role="button" class="btn btn-success" style="padding: 0.7em 2em;" @click="showAttributeCreator()">Create attribute</button>

                    <a class="btn btn-outline-secondary btn-lg" href="https://www.transparentchoice.com/user-guide/attributes" title="User guide: Configure attributes" target="_blank">
                        <i class="fa fa-info" aria-hidden="true"></i>
                    </a>
                </div>
            </div>
            <hr style="border-color: #bbb; margin: 20px 0 60px;" />

            <div class="row">
                <div class="col-lg-4 offset-lg-8">
                    <div class="input-group input-group-lg">
                        <input type="search" placeholder="Search for an attribute" class="form-control" v-model="searchPhrase">
                        <span class="input-group-append">
                            <span class="input-group-text"><i class="fa-solid fa-magnifying-glass" aria-hidden="true"></i></span>
                        </span>
                    </div>
                </div>
            </div>


            <div style="margin-top: 50px;" v-for="s in sectionsView">
                <div>
                    <h4 class="pull-left" style="margin: 0; padding: 0;">
                        <a class="text-dark" @click="s.Expanded = !s.Expanded">
                            <i class="fa" :class="{'fa-angle-right': !s.Expanded, 'fa-angle-down': s.Expanded}"></i>
                            <span v-if="s.Name" style="color: black !important;">{{s.Name}}</span>
                            <span v-if="!s.Name" style="color: black !important; font-style: italic;">Unnamed</span>
                        </a>
                    </h4>
                    <div class="pull-right">
                        <a class="text-dark" @click="showAttributesSectionEditor(s)">Edit section name</a> | <a class="text-dark" @click="showAttributeCreator(s.Name)">Create attribute</a>
                    </div>
                    <div class="clearfix"></div>
                </div>
                <div v-if="s.Expanded">
                    <div>
                        <div style="margin-top: 20px; overflow-y: visible;">

                            <table class="table table-bordered table-hover table-browser" style="margin-bottom: 0 !important;">
                                <thead>
                                    <tr>
                                        <th class="sortable" @click="s.orderByName()" :class="{ 'selected': s.OrderBy === 'name' }">
                                            <span class="text-uppercase font-weight-normal">Name</span>
                                            <span class="fa-stack">
                                                <i class="fa fa-sort-asc fa-stack-1x" :class="{ 'selected': s.OrderBy === 'name' && s.OrderByDescending === false }"></i>
                                                <i class="fa fa-sort-desc fa-stack-1x" :class="{ 'selected': s.OrderBy === 'name' && s.OrderByDescending === true }"></i>
                                            </span>
                                        </th>
                                        <th class="sortable text-center" style="width: 180px;" @click="s.orderByModified()" :class="{ 'selected': s.OrderBy === 'modified' }">
                                            <span class="text-uppercase font-weight-normal">Updated on</span>
                                            <span class="fa-stack">
                                                <i class="fa fa-sort-asc fa-stack-1x" :class="{ 'selected': s.OrderBy === 'modified' && s.OrderByDescending === false }"></i>
                                                <i class="fa fa-sort-desc fa-stack-1x" :class="{ 'selected': s.OrderBy === 'modified' && s.OrderByDescending === true }"></i>
                                            </span>
                                        </th>
                                        <th style="width: 120px;"></th>
                                    </tr>
                                </thead>

                                <tbody>
                                    <tr v-for="attr in s.AttributesView"
                                        :key="attr.Id"
                                        :class="{'bg-danger': attr.IsSystem, 'table-warning': attr.IsCorporate}">
                                        <td>
                                            <h5>
                                                <template v-if="!attr.IsCorporate">
                                                    <a class="text-dark" @click="showAttributeEditor(attr)">{{attr.Name}}</a>
                                                </template>
                                                <template v-else>
                                                    <span class="text-muted">{{attr.Name}}</span>
                                                </template>
                                                <br />
                                                <small>{{attr.InputTypeDisplayName}}</small>
                                            </h5>
                                        </td>
                                        <td class="text-center">
                                            <span>{{getModifiedDateStr(attr)}}</span><br />
                                            <small>{{getModifiedTimeStr(attr)}}</small>
                                        </td>
                                        <td>
                                            <template v-if="attr.IsCorporate">
                                                <button type="button"
                                                        class="btn btn-outline-secondary"
                                                        disabled
                                                        aria-disabled="true">
                                                    Enterprise
                                                </button>
                                            </template>
                                            <template v-else>
                                                <div class="dropdown">
                                                    <button type="button"
                                                            class="btn btn-outline-secondary dropdown-toggle"
                                                            data-toggle="dropdown"
                                                            aria-haspopup="true"
                                                            aria-expanded="false">
                                                        Actions
                                                    </button>
                                                    <div class="dropdown-menu dropdown-menu-right">
                                                        <a class="dropdown-item" @click="showAttributeEditor(attr)">Edit attribute</a>
                                                        <a class="dropdown-item" @click="showAttributeCloner(attr)">Clone attribute</a>
                                                        <div class="dropdown-divider"></div>
                                                        <a class="dropdown-item" @click="showAttributeDependenciesViewer(attr.Id)">View dependencies</a>
                                                        <div class="dropdown-divider"></div>
                                                        <a class="dropdown-item" @click="showAttributeDeleter(attr.Id)">Delete attribute</a>
                                                    </div>
                                                </div>
                                            </template>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>

                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<style scoped>

</style>
